var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import Button from "@irati/ui/src/Button";
import id from "@irati/utils/id";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", ";\n  width: 210px;\n  border-radius: 3px;\n  box-shadow: ", ";\n"], ["\n  background: ", ";\n  padding: ", ";\n  width: 210px;\n  border-radius: 3px;\n  box-shadow: ", ";\n"])), greys.white, padding.tiny, function (_a) {
    var theme = _a.theme;
    return theme.shadows.low;
});
var ButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var Confirm = /** @class */ (function (_super) {
    __extends(Confirm, _super);
    function Confirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleConfirm = function () {
            _this.props.onConfirm();
        };
        _this.handleCancel = function () {
            _this.props.onCancel();
        };
        return _this;
    }
    Confirm.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, apolloState = _a.apolloState, intl = _a.intl;
        return (React.createElement(Container, { className: className },
            children,
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { id: id("btn-cancel", this.props), onClick: this.handleCancel }, getResolvedMessage(this, "cancelLabel")),
                React.createElement(Button, { id: id("btn-confirm", this.props), onClick: this.handleConfirm, primary: true, apolloState: apolloState }, getResolvedMessage(this, "confirmLabel"))),
            apolloState.error && React.createElement("div", null, intl.formatMessage({ id: apolloState.errorMsg }))));
    };
    Confirm.defaultProps = {
        id: "confirm",
        confirmLabel: "recognition.confirm.confirmLabel",
        cancelLabel: "recognition.confirm.cancelLabel",
        onConfirm: function () { },
        onCancel: function () { },
        className: undefined
    };
    return Confirm;
}(PureComponent));
export default injectIntl(Confirm);
var templateObject_1, templateObject_2;
